import { combineReducers } from 'redux'

import { SELECT_LESSON_FOR_ASSIGN } from '../../actions/admin/adminLessonActions'

const initialViewState = {
  selectedLesson: null
}
const viewState = (state = initialViewState, action) => {
  switch (action.type) {
    case SELECT_LESSON_FOR_ASSIGN:
      return {
        ...state,
        selectedLesson: action.selectedLesson
      }
    default:
      return state
  }
}

export default combineReducers({
  viewState
})
